var _title, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoGitlab = function SvgLogoGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "GitLab")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m23.803 43.322 7.665-23.578h-15.32l7.655 23.578Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m5.412 19.744-2.334 7.164c-.212.65.017 1.368.574 1.774l20.15 14.64-18.39-23.578Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M5.412 19.744H16.15L11.528 5.545c-.237-.727-1.267-.727-1.512 0L5.412 19.744Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m42.205 19.744 2.326 7.164a1.588 1.588 0 0 1-.575 1.774l-20.153 14.64 18.402-23.578Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M42.205 19.744H31.468L36.08 5.545c.236-.727 1.267-.727 1.512 0l4.612 14.199Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M42.205 19.744 23.803 43.322l7.665-23.578h10.737ZM16.149 19.744l7.654 23.578-18.39-23.578h10.736Z"
  })));
};
export default SvgLogoGitlab;